import '../global.js';
import * as Helper from './Helpers';
import gsap from 'gsap';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';
import ScrollTrigger from 'gsap/ScrollTrigger';
import LogoMobileWidth from './LogoMobileWidth.js';
import { disableScrollingOnIos ,enableScrollingOnIos} from './Helpers';

gsap.registerPlugin(ScrollTrigger);

class CompaniesFilters {

	static instance = null;

	static create(options) {
		if (!CompaniesFilters.instance) {
			CompaniesFilters.instance = new CompaniesFilters(options);
		}
		return CompaniesFilters.instance;
	}

	static destroy(data) {
		if (CompaniesFilters.instance) {
			CompaniesFilters.instance.beforeDestroy(data);
			CompaniesFilters.instance = null;
		}
	}

	get defaultOptions() {
		return {
			container: document,
		};
	}


	constructor(options) {
		this.options = Object.assign({}, this.defaultOptions, options);
		this.isEnabled = true;
		this.lastScrollPosition = 0;
		this.simpleBar;
		this.isSimpleBar = false;

		this.applied = $('#search').val() ? true : false;
		this.AjaxLoadOnScroll = this.ajaxLoadOnScroll.bind(this);
		this.stickyFilters = this.stickyFilters.bind(this);
		this.mm = gsap.matchMedia();
		this.onResize = this.onResize.bind(this);
		this.init();
		this.previousSearch = $('#search').val();
		
		setTimeout(() => {
			window.scroller.update();
		}, 1000);
	}

	init() {
		this.htmlEl = document.documentElement;
		this.bodyEl = document.body;
		this.headerFilter = document.querySelector('#section-companies .filter-heading');
		this.wrapper = document.querySelector('.companies-wrapper');
		this.header = document.querySelector('.header');
		this.Filters();
		this.onResize();
		setTimeout(() => {
			this.searchAutocomplete();
		}, 300);
		this.initTransition();
		this.onScrollActions();
		this.initStickyFilters();
		this.initResize();
		this.showCompany();
		this.identifyFounder();
		this.applyURLFilters();
	}
	
	initTransition() {
		$('#section-companies .row-grid .col').addClass('fade-in');
	}

	updateURL(locations, stages, sectors, search) {
		const params = new URLSearchParams(location.search);

		if (locations.length) {
			params.set('location', locations.join(','));
		} else {
			params.delete('location');
		}

		if (stages.length) {
			params.set('stage', stages.join(','));
		} else {
			params.delete('stage');
		}

		if (sectors.length) {
			params.set('sector', sectors.join(','));
		} else {
			params.delete('sector');
		}

		if (search.length) {
			params.set('search', search);
		} else {
			params.delete('search');
		}

		const newURL = `${location.pathname}?${params.toString()}`;
		history.pushState({}, '', newURL);
		window.barba.history.add(newURL, 'companies');
	}

	Filters() {

		$('.filter-wrap :checkbox').on('change', (e) => {

			let value = $(e.target).val();

			if (value === 'all') {
				$(e.target).closest('ul').find('li input').prop('checked', false);
				$(e.target).prop('checked', true);
			} else {
				$(e.target).parents('ul').find('.filter-all').prop('checked', false);

				if (
					!$(e.target)
						.closest('ul')
						.find('li input:not(.filter-all)')
						.is(':checked')
				) {
					$(e.target).closest('ul').find('.filter-all').prop('checked', true);
				}


			}
			
			this.filterCount();
			this.getResults(this.getFilters());
		});

		$(document).ready(() => {
			if ($('body').hasClass('page-companies-india')) {
				this.filterCount();
				this.getResults(this.getFilters(), false);
			}
		});

		$('#reset-filters').on('click', () => {
			this.resetFilters();
			this.filterCount();
			this.getResults(this.getFilters(), true);
		});

		$('#reset-filters-mobile').on('click', () => {
			this.resetFilters();
			this.filterCount();
			this.getResults(this.getFilters(), true);
		});

		$(document).on('click', '.ui-menu-item-wrapper', (e) => {
			this.applied = true;
			this.previousSearch = $(e.target).text();
			this.getResults(this.getFilters(), true);
			this.filterCount();
		});

		$(document).on('submit', 'form.search', (e) => {
			e.preventDefault();
			this.applied = true;
			this.previousSearch = $(e.target).find('input').val();
			this.getResults(this.getFilters(), true);
			this.filterCount();
		});

		$(document).on('click', '.load-more-companies', (e) => {
			let slug = $(e.target).data('slug');
			let page = $(e.target).data('page');
			let scrollPosition = this.getScrollPosition();

			$(e.target)
				.html(`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="16px" height="16px" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid">
                <circle cx="12" cy="12" fill="none" stroke="#ffffff" stroke-width="2" r="8" stroke-dasharray="18.84955592153876 8.283185307179586">
                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 12 12;360 12 12" keyTimes="0;1"/>
                </circle>
            </svg>`);

			setTimeout(() => {
				this.loadMore(
					this.getFilters(),
					slug,
					parseInt(page) + 1,
					scrollPosition,
					this.previousSearch,
				);
			}, 200);
		});

		$('.filter-wrap #search').on('keyup', (e) => {
			if (!$('.filter-wrap #search').val() && this.applied) {
				//Scroll to top
				this.previousSearch = '';
				this.getResults(this.getFilters(), true);
				this.filterCount();
				this.applied = false;
			}
			if ($('#search').val()) {
				$('form.search').addClass('filled');
			} else {
				$('form.search').removeClass('filled');
			}
		});

		$('.page-companies, .page-companies-india').find('.reset-field').on('click', (e) => {
			const params = new URLSearchParams(location.search);
			$('#search').val('');
			$('form.search').removeClass('filled');
			if (this.applied) {
				this.previousSearch = '';
				this.getResults(this.getFilters(), true);
				this.applied = false;
			}
		});
	}

	// Fetch checked filters, search field and nonce
	getFilters = () => {
		let locations = [];
		let stages = [];
		let sectors = [];

		$('#location-filter input:checked').each((index, element) => {
			locations.push($(element).val());
		});

		$('#stage-filter input:checked').each((index, element) => {
			stages.push($(element).val());
		});

		$('#sector-filter input:checked').each((index, element) => {
			sectors.push($(element).val());
		});

		let search = this.previousSearch;
		let spotlight = $(".filter").data('spotlight-list');

		return {locations, stages, sectors, search, spotlight};
	};

	// Ajax call
	getResults({locations, stages, sectors, search, spotlight}, shouldScroll) {
		$('#smooth-wrapper').after('<div class="loading"></div>');
		const sectorsStringList = (sectors.length > 0 && !sectors.includes('all')) ? sectors.join(', ') : '';
		$('#section-companies .section-spotlight-companies .current_sector_filters').text(sectorsStringList);
		const props = {
			locations,
			stages,
			sectors,
			search,
			spotlight,
		}

		const prefilled_location = $('.filter-heading').data('prefilled-location');
		if (prefilled_location && prefilled_location.length > 0 && props.locations.length === 0) {
			props.locations = [prefilled_location];
		}
		
		this.restApiLoadCompanies(props, (result) => {
			if ($('#section-companies #all-companies-list ul').length > 0) {
				if (typeof result.html_all === 'string' && result.html_all.length > 5) {
					$('#section-companies #all-companies-list').attr('data-paged', 1);
					$('#section-companies #all-companies-list').attr('data-is-loading', '');
					$('#section-companies #all-companies-list ul').html(result.html_all);
				} else {
					$('#section-companies #all-companies-list ul').html('<div class="no-result">No results</div>');
				}
			}

			if ($('#section-companies #spotlight-companies-list ul').length > 0) {
				if (typeof result.html_spotlight === 'string' && result.html_spotlight.length > 5) {
					$('#section-companies #spotlight-companies-list ul').html(result.html_spotlight);
					$('#section-companies #spotlight-companies-list').removeClass('hide');
				} else {
					$('#section-companies #spotlight-companies-list ul').html('<div class="no-result">No results</div>');
					$('#section-companies #spotlight-companies-list').addClass('hide');
				}
			}

		}, () => {


			Helper.OpenCloseNew();
			Helper.HoverClassOnParent();
			$('.loading').remove();

			if (shouldScroll) {
				this.mm.add('(max-width: 991px)', () => {
					enableScrollingOnIos();
					setTimeout(() => {
						if(window.scroller) {
							window.scroller.scrollTo($('#section-companies .section-portfolio-heading')[0], {
								duration: 100,
								offset: -this.headerHeight,
							});

						} else {
							window.scrollTo(0, $('#section-companies .section-portfolio-heading').offset().top - this.headerHeight);
						}
					}, 500);
				})

				this.mm.add('(min-width: 992px)', () => {
					setTimeout(() => {
						window.scroller.scrollTo($('#section-companies .section-portfolio-heading')[0], {
							duration: 100,
							offset: -this.headerHeight,
						});
					}, 0);

				});
			}

			window.updateLocoAndScrollTrigger();
			this.animationListCompany();

		});

		this.updateURL(locations, stages, sectors, search);
	}

	loadMore = (
		{locations, stages, sectors, search, spotlight},
		slug,
		page,
		scrollPosition,
	) => {
		const url = new URL('/wp-json/api/v1/load-more-companies', process.env.MIX_BASE_URL);

		fetch(url.toString(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				locations,
				stages,
				sectors,
				search,
				slug,
				page
			})
		})
		.then(response => response.json())
		.then(result => {
			setTimeout(() => {
				const parent = $('.row-' + slug);
				parent.append(result.html);
				if (result.is_last) {
					$(`[data-slug='${slug}']`).hide();
				}
				$(`[data-slug='${slug}']`).html('Dive deeper');
				$(`[data-slug='${slug}']`).data('page', page);

				const appended = $('#section-companies .col:not(.fade-in)');

				gsap.set(appended, { alpha: 0 });
				gsap.set(parent.parent(), { height: '100%' });
				// animation
				const invert = 1;

				setTimeout(() => {
					gsap
						.timeline({
							onComplete: () => {
								if (!appended.hasClass('fade-in')) {
									appended.addClass('fade-in');
								}
							},
						})
						.to(appended, { y: 50, alpha: 0, duration: 1, delay: 0.2 })
						.to(
							appended,
							{
								y: 0,
								alpha: 1,
								duration: 1,
								ease: 'power4.out',
								stagger: 0.1 * invert,
							},
							'-=0.5'
						);
					LogoMobileWidth.create();
				}, 0);
			}, 0);
		})
		.catch(error => {
			console.error('Error:', error);
		});
	};

	filterCount = () => {
		let dropdowns = ['location', 'stage', 'sector', 'length'];
		let number = $('.filter-wrap input:checked').length;

		dropdowns.forEach((dropdown) => {
			let activeFilters = $(`#${dropdown}-filter input:checked`);
			let activeFiltersNumber = activeFilters.length;
			let selected = [];

			activeFilters.each((index, element) => {
				selected.push($(element).val());
			});

			if (selected.includes('all')) {
				activeFiltersNumber -= 1;
				number -= 1;
			}

			if (activeFiltersNumber > 0) {
				$(`#${dropdown}-filter .filter-count`).html(`(${activeFiltersNumber})`);
			} else {
				$(`#${dropdown}-filter .filter-count`).html('');
				$(`#${dropdown}-filter input.filter-all`).prop('checked', true);
			}
		});

		if (number || $('.filter-wrap #search').val().length) {
			number = number ? `(${number})` : '';
			$('#section-companies .filter-opener .filter-count').html(number);
			$('#section-companies #reset-filters .filter-count').text(number);

			if (window.innerWidth > 767) {
				$('#reset-filters').fadeIn();
			}
		} else {
			$('#section-companies #reset-filters').fadeOut();
			$('#section-companies .filter-opener .filter-count').html('');
		}
	};

	// Reset all filters
	resetFilters = () => {
		$('.filter-wrap input:checked').prop('checked', false);
		$('#section-companies #search').prop('value', '');
		window.updateLocoAndScrollTrigger();
		this.onScrollActions();
		$('form.search').removeClass('filled');
		this.previousSearch = '';
	};

	// Search autocomplete
	searchAutocomplete = () => {
		this.searchContainerCompanies = $('#search')[0]
		if (typeof window.companiesAutocomplete !== 'undefined') {
			$(this.searchContainerCompanies).autocomplete({
				source: window.companiesAutocomplete,
				appendTo: $('.filter-wrap .inner .search')[0],
				minLength: 1,
				autoFocus: false,
				open: (e) => {
					$(e.target).next('.ui-autocomplete').addClass('is-active');
					if (!this.isSimpleBar) {
						this.initSimplebar();
					}
				},
				select: (event, ui) => {
					$(event.target).removeClass('active');
					$(event.target).next('.ui-autocomplete').removeClass('is-active');
				},
				close: () => {
					this.destroySimpleBar();
				},
			});
		}
	};

	initSimplebar() {
		this.isSimpleBar = true;
		this.SimpleBar = new SimpleBar($('.ui-autocomplete')[0]);
	}

	destroySimpleBar() {
		if (this.isSimpleBar) {
			this.isSimpleBar = false;
			this.SimpleBar.unMount();
		}
	}

	enableAutocomplete = () => {
		$('#search').autocomplete('enable');
	};

	getScrollPosition() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}

	destroyAutoComplete() {
		$('#search').autocomplete('destroy');
		if (typeof window.companiesAutocomplete !== 'undefined') {
			window.companiesAutocomplete = undefined;
		}
	}

	beforeDestroy(data) {
		this.destroyAutoComplete();
		this.destroySimpleBar();
		this.AjaxLoadOnScroll = null;
		this.headerFilter = null;
		this.wrapper = null;
		this.boundWrapper = null;
		this.headerHeight = null;
		this.header = null;
		this.lastScrollPosition = null;
		this.initStickyFilters = null;
		this.isSimpleBar = null;
		this.SimpleBar = null;
		window.removeEventListener('resize', this.onResize);
	}

	restApiLoadCompanies(props = {}, callbackSuccess, callbackComplete) {
		const url = new URL('/wp-json/api/v1/companies-filters', process.env.MIX_BASE_URL);

		fetch(url.toString(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(props)
		})
		.then(response => {
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			return response.json();
		})
		.then(result => {
			callbackSuccess(result);
		})
		.catch(error => {
			console.error('Error:', error);
		})
		.finally(() => {
			callbackComplete();
		});
	}

	initResize() {
		window.addEventListener('resize', this.onResize);
	}

	onResize() {
		this.headerHeight = this.header.offsetHeight;
		this.isSmoothScroll = this.htmlEl.classList.contains('has-scroll-smooth');
		this.isMobile = window.matchMedia('(max-width: 767px)').matches;
	}

	onScrollActions() {
		window.scroller.on('scroll', this.AjaxLoadOnScroll);
		window.scroller.on('call', (func, action) => {
			if (this.isSmoothScroll) {
				if (func === 'companiesFilter') {
					document.body.classList[action === 'enter' ? 'add' : 'remove']('is-filter-sticky');
				}
			}
		});
	}

	ajaxLoadOnScroll() {
		const container = this.options.container.querySelector('#all-companies-list');
		if (container === null) return;
		const companiesList = container.querySelector('ul.companies-list');
		const isLoading = container.dataset.isLoading;
		const paged = parseInt(container.dataset.paged) + 1;
		const trigger = container.offsetTop + (container.offsetHeight - (window.outerHeight * 3));


		if (window.scroller.scroll.instance.scroll.y > trigger && !isLoading) {
			const props = this.getFilters();

			container.dataset.isLoading = 'loading';
			container.dataset.paged = paged;

			this.restApiLoadCompanies({...props, ...{paged}}, (data) => {
				if (typeof data.html_all === 'string' && data.html_all.length > 5) {

					$(companiesList).append(data.html_all);
					window.setTimeout(() => {
						container.dataset.isLoading = '';
						window.updateLocoAndScrollTrigger();
						this.animationListCompany();
					}, 200)
				}
			}, () => {

			});
		}
	}

	animationListCompany() {
		this.options.container.querySelectorAll('.ready-appear-list').forEach((box) => {
			let tlnew = gsap.to(box, {
				scrollTrigger: {
					trigger: box,
					start: "top 110%",
					end: "bottom 90%",
					scroller: "[data-scroll-container]",
					markers: false

				},
				y: 0,
				autoAlpha: 1,
				duration: 0.75,
				ease: 'circ.out',
				delay: 0.1,
				clearProps: 'autoAlpha',
				onStart: (a) => {
					box.classList.add('list-animated');
					box.classList.remove('ready-appear-list');
				},
				onComplete: (a) => {
					tlnew.scrollTrigger.kill();
					tlnew.kill();
					tlnew = null;
				},
			})
		})
	}

	stickyFilters() {
		if (this.headerFilter === null) return;

		this.boundWrapper = this.wrapper.getBoundingClientRect().top + window.scroller.scroll.instance.scroll.y - this.headerHeight;
		const scroll = window.scroller.scroll.instance.scroll.y;

		if (!this.isSmoothScroll) {
			this.stickyFilterTouchPin(scroll);
		}

		this.stickyFiltersHandler(scroll);
		this.lastScrollPosition = scroll
	}

	stickyFilterTouchPin(scroll) {
		if (scroll > this.boundWrapper) {
			this.headerFilter.classList.add('sticky');
			this.headerFilter.style.top = this.headerHeight - 1 + 'px';
			this.wrapper.style.paddingTop = this.headerFilter.offsetHeight + 'px';
			this.bodyEl.classList.add('is-filter-sticky');
		} else {
			this.headerFilter.classList.remove('sticky');
			this.headerFilter.style.top = '';
			this.wrapper.style.paddingTop = '';
			this.bodyEl.classList.remove('is-filter-sticky');
			this.headerFilter.classList.remove('active');
			this.headerFilter.classList.remove('removed');
		}
	}

	stickyFiltersHandler(scroll) {
		if (scroll > this.boundWrapper + 100) {
			const scrollDelta = scroll - this.lastScrollPosition;
			if (scrollDelta > 1) {
				this.headerFilter.classList.remove('active');
				this.headerFilter.classList.add('removed');

				if (!this.isMobile) {
					this.closeTheDropdownFilter();
				}

			} else if (scrollDelta < -1) {
				this.headerFilter.classList.add('active');
				this.headerFilter.classList.remove('removed');
				if (!this.isMobile) {
					this.closeTheDropdownFilter();
				}
			}
		} else {
			this.headerFilter.classList.remove('active');
			this.headerFilter.classList.remove('removed');
		}
	}

	initStickyFilters() {
		window.scroller.on('scroll', this.stickyFilters);
	}

	closeTheDropdownFilter() {
		this.options.container.querySelectorAll('[data-more]').forEach((item) => {
			if (item.classList.contains('active')) {
				item.classList.remove('active');
				$(item).next().stop().slideToggle(200);

			}
		});
	}

	showCompany() {
		if (document.querySelector('.page-companies-india')) {
		  const allCompany = document.querySelectorAll('.page-companies-india [data-appear-list]');
		  const data = Array.from(allCompany).slice(0, 5);
		  data.forEach((item) => {
			item.removeAttribute('data-appear-list');
		  });
		}
	  }
	
	  identifyFounder() {
		const allCompanyFounders = document.querySelectorAll('[data-company-id]');
		allCompanyFounders.forEach((item) => {
		  item.addEventListener('click', (e) => {
			if (item.hasAttribute('data-spotlight-founders-list')) {
			  	sessionStorage.setItem('founder', 'true');
			} else{
				sessionStorage.setItem('founder', 'false');
			}
		  });
		});
	}

	applyURLFilters() {
		const params = new URLSearchParams(location.search);
		
		const locationParam = params.get('location');
		if (locationParam) {
			const locations = locationParam.split(',');
			locations.forEach(location => {
				const checkbox = $(`#location-filter input[value="${location}"]`);
				if (checkbox.length) {
					checkbox.prop('checked', true);
				}
			});
		}
		
		const stageParam = params.get('stage');
		if (stageParam) {
			const stages = stageParam.split(',');
			stages.forEach(stage => {
				const checkbox = $(`#stage-filter input[value="${stage}"]`);
				if (checkbox.length) {
					checkbox.prop('checked', true);
				}
			});
		}
		
		const sectorParam = params.get('sector');
		if (sectorParam) {
			const sectors = sectorParam.split(',');
			sectors.forEach(sector => {
				const checkbox = $(`#sector-filter input[value="${sector}"]`);
				if (checkbox.length) {
					checkbox.prop('checked', true);
				}
			});
		}
		
		const searchParam = params.get('search');
		if (searchParam) {
			$('#search').val(searchParam);
			this.previousSearch = searchParam;
			$('form.search').addClass('filled');
		}
		
		if (locationParam || stageParam || sectorParam || searchParam) {
			this.filterCount();
			this.getResults(this.getFilters(), false);
		}
	}
}

export default CompaniesFilters;